import { parseISO, addDays, differenceInDays } from 'date-fns';
import { AccessRequestItem } from '../../hooks/useUserPermissions';

export const getDaysLeftForAccessExpiry = (lastUpdatedAtISOString: string, expiredIn: number) => {
  const lastUpdatedDate = parseISO(lastUpdatedAtISOString);
  const expiryDate = addDays(lastUpdatedDate, expiredIn);
  const today = new Date();
  const daysLeft = differenceInDays(expiryDate, today);
  return daysLeft > 0 ? daysLeft : 0;
};

export function countItemsExpiringWithinDays(items: AccessRequestItem[], daysThreshold: number) {
  return items.filter((item) => {
    if (item.status !== 'Approved') return false;
    const daysLeft = getDaysLeftForAccessExpiry(item.statusTimestamp, 365);
    if (daysThreshold === 0) {
      return daysLeft <= 0;
    }
    return daysLeft <= daysThreshold && daysLeft > 0;
  }).length;
}
